import React from 'react';
import withIcon from '../utilities/withIcon';

const IconMegaphone = () => {
  return (
    <g>
      <path d="m15.0146 1.6543a.7.7 0 0 0 -.7.7v.7484l-10.9982 2.0173a.6936.6936 0 0 0 -.4283.2687l-1.685-.5513a.7.7 0 0 0 -.918.665v4.7251a.699.699 0 0 0 .918.665l1.6849-.5514a.6936.6936 0 0 0 .4283.2687l.9512.1744v1.8978a.7005.7005 0 0 0 .5762.689l5.3506.9634a.71.71 0 0 0 .124.0112.7.7 0 0 0 .7-.7v-1.623l3.2959.6045v.7484a.7.7 0 0 0 1.4 0v-11.021a.7.7 0 0 0 -.6996-.7002zm-5.3964 11.1538-3.95-.7114v-1.0318l3.95.7114zm-7.9326-6.34 1.0566.3457v2.1022l-1.0566.3457zm2.457 2.87v-2.946l10.1719-1.8662v6.6782z" />
    </g>
  );
};

export default withIcon(IconMegaphone);
